
const AppEnv = {
    isProduction: false,
    /* theming config url */
}

export default AppEnv;